var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduleTabActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "schedule (3) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.6228 3.12445H15.7225V2.32465C15.7225 1.81527 15.3096 1.40234 14.8002 1.40234C14.2909 1.40234 13.8779 1.81527 13.8779 2.32465V3.12445H10.9223V2.32465C10.9223 1.81527 10.5094 1.40234 10 1.40234C9.49066 1.40234 9.07773 1.81523 9.07773 2.32465V3.12445H6.12215V2.32465C6.12215 1.81527 5.70922 1.40234 5.19984 1.40234C4.69047 1.40234 4.27754 1.81527 4.27754 2.32465V3.12445H2.37723C1.06434 3.12445 0 4.18879 0 5.50168V6.72734H20V5.50164C20 4.18875 18.9357 3.12445 17.6228 3.12445Z",
    fill: "#0C66E4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0 7.89844V16.2234C0 17.5342 1.06645 18.6006 2.37723 18.6006H17.6227C18.9336 18.6006 20 17.5342 20 16.2234V7.89844H0ZM12.9106 12.9547C12.9106 13.2783 12.6482 13.5406 12.3246 13.5406H10.8298V15.0355C10.8298 15.3591 10.5675 15.6214 10.2439 15.6214H9.75613C9.43254 15.6214 9.1702 15.3591 9.1702 15.0355V13.5406H7.67535C7.35176 13.5406 7.08941 13.2783 7.08941 12.9547V12.467C7.08941 12.1434 7.35176 11.881 7.67535 11.881H9.1702V10.3862C9.1702 10.0626 9.43254 9.80023 9.75613 9.80023H10.2439C10.5675 9.80023 10.8298 10.0626 10.8298 10.3862V11.881H12.3246C12.6482 11.881 12.9106 12.1434 12.9106 12.467V12.9547Z",
    fill: "#0C66E4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleTabActive);
export default __webpack_public_path__ + "static/media/scheduleTabActive.9fcd6a4b59de066daddc13063cc9e9bc.svg";
export { ForwardRef as ReactComponent };